module.exports = __webpack_public_path__ + "static/media/partners-image-5.92529aaa.svg";